import { render } from "./topicApplyDetail.vue?vue&type=template&id=3b386aad&scoped=true"
import script from "./topicApplyDetail.vue?vue&type=script&lang=js"
export * from "./topicApplyDetail.vue?vue&type=script&lang=js"

import "./topicApplyDetail.vue?vue&type=style&index=0&id=3b386aad&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b386aad"]])

export default __exports__